import { render, staticRenderFns } from "./place_installations.vue?vue&type=template&id=5c7dd840&scoped=true&"
import script from "./place_installations.vue?vue&type=script&lang=js&"
export * from "./place_installations.vue?vue&type=script&lang=js&"
import style0 from "./place_installations.vue?vue&type=style&index=0&id=5c7dd840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7dd840",
  null
  
)

export default component.exports